import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ShareModalOptions {
  autoGenerate?: '12-step-status' | 'step-four-inventories';
}

interface ShareContextType {
  isShareModalOpen: boolean;
  openShareModal: (options?: ShareModalOptions) => void;
  closeShareModal: () => void;
  shareModalOptions?: ShareModalOptions;
}

const ShareContext = createContext<ShareContextType | undefined>(undefined);

interface ShareProviderProps {
  children: ReactNode;
}

export const ShareProvider: React.FC<ShareProviderProps> = ({ children }) => {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [shareModalOptions, setShareModalOptions] = useState<ShareModalOptions | undefined>(undefined);

  const openShareModal = (options?: ShareModalOptions) => {
    setShareModalOptions(options);
    setIsShareModalOpen(true);
  };

  const closeShareModal = () => {
    setIsShareModalOpen(false);
    setShareModalOptions(undefined);
  };

  return (
    <ShareContext.Provider value={{
      isShareModalOpen,
      openShareModal,
      closeShareModal,
      shareModalOptions,
    }}>
      {children}
    </ShareContext.Provider>
  );
};

export const useShare = (): ShareContextType => {
  const context = useContext(ShareContext);
  if (context === undefined) {
    throw new Error('useShare must be used within a ShareProvider');
  }
  return context;
}; 